import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Erfolgreich angemeldet");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center bg-slate-50 px-4 py-12" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-slate-200 p-8 md:p-10 space-y-6">
        <div className="flex items-center gap-3 pb-2 border-b border-slate-200">
          <Lock size={20} className="text-slate-900" />
          <h1 className="font-heading font-bold text-xl text-slate-900">Admin Anmeldung</h1>
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-2 block">E-Mail</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
            className="w-full border border-slate-200 px-3 py-3 text-sm focus:outline-none focus:border-slate-900" autoComplete="email" />
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-slate-500 font-medium mb-2 block">Passwort</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
            className="w-full border border-slate-200 px-3 py-3 text-sm focus:outline-none focus:border-slate-900" autoComplete="current-password" />
        </div>

        <button type="submit" disabled={submitting} data-testid="admin-login-submit"
          className="w-full bg-slate-900 text-white py-3 text-sm font-medium hover:bg-red-600 transition-crisp disabled:opacity-50">
          {submitting ? "Anmelden…" : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
